export default __webpack_public_path__ + "static/Logo-Dimas-fb81552fedfc05067a748be5dbd32776.svg";